<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="8" md="8">
        <div class="pt-5">
          <v-card class="mx-auto my-12" max-width="1100">
            <v-card-text>
              <markdown-it-vue class="md-body" :content="issueMarkdownText" />
            </v-card-text>
            <!-- 来自管理员的请求才会返回联系方式 -->
            <v-card-text style="color:red;" v-if="this.contactDetails!=''">
            <strong style="color:red;">联系方式：</strong>
              {{contactDetails}}
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <v-card class="mx-auto my-0" max-width="1100" v-if="show_comments">
      <v-card-text>
        <!-- 递归生成评论回复树 -->
        <v-treeview :items="commentList" :rounded="true" open-all :open="openList" expand-icon="$subgroup"> 
          <template v-slot:prepend="{ item, open }">
            <v-card width="1100px">
              <!-- 评论回复头部 两行 -->
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6">
                    <v-avatar class="mr-5 my-auto" size="25" style="cursor:pointer;">
                      <img v-if="item.avatarUrl==''" src="@/assets/tourist_avatar.jpg"/>
                      <img v-else :src="item.avatarUrl"/>
                    </v-avatar>
                    {{item.nickname}}
                  </v-list-item-title>
                  <v-list-item-subtitle>{{(new Date(item.createDate)).toLocaleString()}}&nbsp;&nbsp;{{ new Date(item.createDate) | dateFormat }}</v-list-item-subtitle>
                  <v-list-item-subtitle style="color:blue;" class="mt-2">{{item.nickname=='fishfish-yu'?'官方答复':''}}{{item.nickname=='talin0x1'?'官方答复':''}}</v-list-item-subtitle>
                </v-list-item-content>
                <v-row align="end" justify="end">
                  <span class="subheading mr-2" v-if="item.floorID != ''">{{item.floorID + '楼'}}</span>
                </v-row>
              </v-list-item>
              <!-- 评论回复主题部分 -->
              <v-md-preview :text="item.text"></v-md-preview>
              <!-- 评论回复内容底部 -->
              <v-card-actions>
                  <v-btn @click="replyHandler(item.id, item.floorID)" class="mr-4" color="primary">回复</v-btn>
                  {{ open ? '' : (item.children.length == 0 ? '' : '共' + item.children.length + '条回复') }}
                  <v-row align="center" justify="end">
                    <v-icon class="mr-2" @click="likeClick" color="primary">
                      mdi-heart
                    </v-icon>
                  </v-row> 
              </v-card-actions>
            </v-card>
            <!-- 回复发布区域 -->
            <div :id="'reply-'+item.id" style="display: none; " class="mt-2">
              <v-md-editor :disabled-menus="[]" @upload-image="handleUploadImage" v-model="text" height="300px" :autofocus="true" v-if="show_reply_editor"></v-md-editor>
              <v-btn type="text" @click="createReply(item.id, item.floorID)" class="mt-1" v-if="show_reply_editor" style="float: right;" color="primary">提交</v-btn>
            </div>
          </template>
        </v-treeview>
      </v-card-text>
      <!-- 评论发布区域 -->
      <div class="ml-13 mr-8">
        <v-md-editor :disabled-menus="[]" @upload-image="handleUploadImage" v-model="text" height="300px" v-if="show_comment_editor" :autofocus="true"></v-md-editor>
      </div>
      <v-row justify="start">
        <v-card-actions >
          <v-btn type="text" @click="createComment" class="mt-3 ml-14" color="primary">{{ show_comment_editor ? '发表你的评论' : '编辑你的评论' }}</v-btn>
        </v-card-actions>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
// 富文本编辑
import MarkdownItVue from 'markdown-it-vue'
import 'markdown-it-vue/dist/markdown-it-vue.css'
// 过滤器 处理时间 显示评论过去多长时间
import { dateFormat } from '../message_tree/util'
export default {
  components: {
    MarkdownItVue
  },
    filters: {
    dateFormat
  },
  data: () => ({
    csrf_token: $cookies.get('csrftoken'),
    // 请求返回数据部分
    // issue生成的github style富文本
    issueMarkdownText: '',
    // 联系方式 管理员请求才会返回
    contactDetails: '',
    // 评论回复数据列表
    commentList: [],
    // 用户填写数据部分
    // 评论回复编辑器内容
    text: '',
    openList: [],
    // 控制整个评论区显示 用于评论后刷新 结合$nextTick使用
    show_comments: true,
    // 绑定每个回复编辑器
    reply_editor_id: '',
    // 控制评论回复编辑器的显示
    show_comment_editor: false,
    show_reply_editor: false,
  }),
  mounted () {
    this.retrieveIssueMarkdown()
    this.retrieveIssueCommentList()
  },
  methods: {
    // 创建一条评论
    async createComment() {
      this.show_reply_editor = false
      this.reply_editor_id = ''
      if(this.show_comment_editor == false){
        this.show_comment_editor = true
        this.text = ''
      }
      else{
        this.show_comment_editor = true
        var formData = new FormData()
        formData.append('nickname', 'tourist')
        formData.append('issue', this.$route.query.id)
        formData.append('text', this.text)
        if(localStorage['avatar_url'] == undefined || localStorage['avatar_url'] == ''){
          formData.append('avatarUrl', '')
        }
        else{
          formData.append('avatarUrl', localStorage['avatar_url'])
        }
        var that = this
        await this.$axios.post('/api/comment/', formData, {headers: {"X-CSRFToken": this.csrf_token, "Content-Type": "multipart/form-data"},})
        .then(function(response){
          that.$toast({
          text: '发布评论成功',
          type: 'success',
          duration: 2000
          })
        })
        .catch(function(error){
          that.show_comment_editor = false
          that.$toast({
            text: error.response.data.message ? error.response.data.message : error,
            type: 'error',
            duration: 6000
          })
        })
        this.retrieveIssueCommentList()
        this.show_comments = false
        await this.$nextTick(function(){
          this.show_comments = true
          this.show_comment_editor = false
        })
      }
    },
    // 创建一条回复
    async createReply(parent_id, floor_id){
      var formData = new FormData();
      formData.append('nickname', 'tourist')
      formData.append('issue', this.$route.query.id)
      formData.append('text', this.text)
      formData.append('parentID', parent_id)
      formData.append('floorID', floor_id)
      if(localStorage['avatar_url'] == undefined || localStorage['avatar_url'] == ''){
        formData.append('avatarUrl', '')
      }
      else{
        formData.append('avatarUrl', localStorage['avatar_url'])
      }
      var that = this
      await this.$axios.post('/api/comment/', formData, {headers: {'X-CSRFToken': this.csrf_token, 'Content-Type': 'multipart/form-data'},})
      .then(function(response){
        that.$toast({
          text: '回复成功',
          type: 'success',
          duration: 2000
        })
      })
      .catch(function(error){
        that.$toast({
          text: error.response.data.message ? error.response.data.message : error,
          type: 'error',
          duration: 6000
        })
      })
      this.retrieveIssueCommentList()
      this.show_comments = false
      await this.$nextTick(function(){
        this.show_comments = true
      })
    },
    // 控制编辑框的显示
    replyHandler(id, floorID) {
      // console.log(this.reply_editor_id)
      // 每次点击回复弹出编辑框时清空一下数据
      this.text = `@${floorID}楼： 
------------------------- `
      this.show_comment_editor = false
      // 点击同一个回复按钮 控制回复编辑框的显示/不显示
      if(this.reply_editor_id == 'reply-'+id){
        var reply_editor = document.getElementById(this.reply_editor_id)
        if(reply_editor.style.display == "none"){
          reply_editor.style.display = "block"
          this.show_reply_editor = true
        }
        else{
          reply_editor.style.display = "none"
          this.show_reply_editor = false
        }
        return
      }
      // 第一次点击任意回复按钮
      if(this.reply_editor_id == ""){
        this.reply_editor_id = 'reply-'+id
      }
      // 点击不同回复按钮 将之前打开的回复编辑框关闭
      else{
        var reply_editor = document.getElementById(this.reply_editor_id)
        reply_editor.style.display = "none"
        this.show_reply_editor = false
      }
      var reply_editor = document.getElementById('reply-'+id)
      reply_editor.style.display = "block"
      this.reply_editor_id = 'reply-'+id
      this.show_reply_editor = true
      // document.querySelector("#anchor_reply").scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
    },
    // 通过接口返回评论列表
    retrieveIssueCommentList(){
      var that = this
      this.$axios.get(`/api/comment/${this.$route.query.id}`)
      .then(function(response){
        var commentList = response.data
        // 先清空一下原来的数据 否则在原有数据上push显示会有问题 需要刷新才会正常显示
        that.commentList=[]
        for(let x in commentList){
          that.commentList.push(commentList[x])
        }
        // console.log(that.commentList)
        // console.log(typeof(JSON.parse(response.data).comments_list[0]))
        // that.commentList.push(JSON.parse(response.data).comment_list[0])
        // console.log(that.commentList)
        // console.log(typeof(that.commentList))
      })
      .catch(function(error){
        alert(error)
      })
    },
    // 通过接口返回Issue富文本内容
    retrieveIssueMarkdown() {
      var that = this
      this.$axios.get(`/api/issues/${this.$route.query.id}/markdown`,)
      .then(function(response){
        that.issueMarkdownText = response.data.issueMarkdownText
        that.contactDetails = response.data.contactDetails
      })
      .catch(function(error){
        alert(error)
      })
    },
    // 点赞
    likeClick() {
      alert("你点赞了一下")
      // this.openList =  [13]
    },
    // 评论编辑框插入图片 拿到files之后上传到文件服务器返回图片S3链接，然后向编辑框中插入对应的富文本内容
    async handleUploadImage(event, insertImage, files){
      var formData = new FormData()
      formData.append('issueCommentImage', files[0])
      var image_s3_url
      var that = this
      await this.$axios.post(`/api/comment/${this.$route.query.id}/image`, formData, {headers: {"X-CSRFToken": this.csrf_token, 'Content-Type': 'multipart/form-data'},})
      .then(function(response){
        image_s3_url = response.data.data.issueCommentImage
      })
      .catch(function(error){
        that.$toast({
          text: error.response.data.message ? error.response.data.message : error,
          type: 'error',
          duration: 6000
        })
      })
      insertImage({
        url: image_s3_url,
        desc: files[0].name,
        // width: 'auto',
        // height: 'auto',
      });
    },
  }
}
</script>